module.exports = __webpack_public_path__ + "static/media/denglu-3.c826e541.jpg";